var lazyList = require('ember-lazy-list')
var BodyViewMixin = require('./body-view-mixin')
var ItemView = require('./item-view')

module.exports = lazyList.ListView.extend(BodyViewMixin, {
    itemViewClass: ItemView
})
